import * as React from "react";
import { cn } from "@/lib/studio/utils";

export interface TermWindowProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title?: React.ReactNode;
  status?: React.ReactNode;
  bodyClassName?: string;
  flat?: boolean;
}

export const TermWindow = React.forwardRef<HTMLDivElement, TermWindowProps>(
  (
    { title, status, className, bodyClassName, flat, children, ...props },
    ref
  ) => (
    <div
      ref={ref}
      className={cn(flat ? "term-window-flat" : "term-window", className)}
      {...props}
    >
      <div className="term-header">
        <div className="flex items-center gap-3 min-w-0">
          {title ? <span className="term-title">{title}</span> : null}
        </div>
        {status ? <span className="term-status">{status}</span> : null}
      </div>
      <div className={cn("p-4", bodyClassName)}>{children}</div>
    </div>
  )
);
TermWindow.displayName = "TermWindow";
